export type Category = {
  name: string;
};

export class ProductConfig {
  constructor(
    public readonly brand_name: string,
    public readonly categories: Array<Category>,
    public readonly id: string,
    public readonly name: string,
    public readonly productVersion: string,
    public readonly productVersionName: string,
    public readonly web360: boolean,
    public readonly pim_tenant_id: string,
    public readonly isVisual: boolean,
    public readonly thumbnailUrl: string,
    public readonly pim_context?: string,
    public readonly saveAndRenderStrategy?: string,
  ) {}
}
